module.exports = __webpack_public_path__ + "img/worm-yummy.12b19dfb.svg";